import { render, staticRenderFns } from "./HelpLineId.vue?vue&type=template&id=74070e38&"
import script from "./HelpLineId.vue?vue&type=script&lang=ts&"
export * from "./HelpLineId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports